import http from "../http-common"

class SliderServices {
    getAllSlider(path:string) {
        return http.get(`/slider?folderPath=${path}`)
    }
}


export default new SliderServices();